import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpService) { }


  getEmails(){
    return this.http.get('email');
  }
  resendEmail(id){
    return this.http.get('email/'+id);
  }
}
